export default __webpack_public_path__ + "static/media/Hand-wraps of the Oxmal.6c330e2e.jpg";